export default "__VITE_ASSET__DxZA1YSg__"